import axios from 'axios';

const apiClient = axios.create({
    // baseURL: 'https://nsar-webapi-preprod.azurewebsites.net/',
    baseURL: 'https://nsar-webapi.azurewebsites.net/',
    // baseURL: 'http://localhost:3000', // json-server
    // 'https://localhost:44336', // .NET webapi local
    withCredentials: false, // This is the default
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

export default {
    getAddress(address: string) {
        return apiClient.get('/search/address/' + address);
    },
    getAddressById(id: number) {
        return apiClient.get('/search/address/id/' + id);
    },
    getProperties(pid: string, showSuggestions: boolean) {
        if (showSuggestions) {
            return apiClient.get('/search/parcel/' + pid + '?suggestions=true');
        }
        return apiClient.get('/search/parcel/' + pid);
    },
    getDistrict(district: string, subDistrict: string) {
        return apiClient.get('/search/districts');
    },
    getSubdistrict(district: string, subDistrict: string) {
        return apiClient.get('/search/subdistricts');
    },
};
